import { render, staticRenderFns } from "./radios.vue?vue&type=template&id=88297f5e&"
import script from "./radios.vue?vue&type=script&lang=ts&"
export * from "./radios.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports